import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GaTrackingEventName,
  GATrackingEventType
} from '../../constants';

export class GaTrackingSignupCheckoutErrorEventModel implements GATrackingEvent {

  constructor(
    private category: string,
    private action: string,
    private label: string,
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.IdamSignUp;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Errors,
      category: this.category,
      label: this.label,
      gtmCustom: {
        category: this.category,
        action: this.action,
      }
    };
  }

}
